<app-sidenav *ngIf="!fullscreen" [@slideInOut]></app-sidenav>
<div class="content" fxFlex>
  <router-outlet></router-outlet>
</div>
